import { render, staticRenderFns } from "./BFlowEdgeProps.vue?vue&type=template&id=685d6835"
import script from "./BFlowEdgeProps.vue?vue&type=script&lang=js"
export * from "./BFlowEdgeProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports